import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChoosetaskformPage } from './choosetaskform';

@NgModule({
  declarations: [
    ChoosetaskformPage,
  ],
  imports: [
    IonicPageModule.forChild(ChoosetaskformPage),
  ],
})
export class ChoosetaskformPageModule {}



// WEBPACK FOOTER //
// ./src/pages/choosetaskform/choosetaskform.module.ts